import BaseAtomFamilyFactory from '../../utils/BaseAtomFamilyFactory';
// import pageRepository from '../repositories/page';
import pageRepository from '../repositories-repo/page';

const operations = {
    __name: "page",
    read: async (action, key) => {
        return [await pageRepository.read(key)];
    },
}

const pageAtomFamily = new BaseAtomFamilyFactory(operations);
export default pageAtomFamily;
